import { EntryPoint, EntryPointType, MailHistoryMode } from '@contact/upgrade';

export class ScriptAnchor implements EntryPoint {
  address = '';
  description = '';
  mailHistoryMode = MailHistoryMode.DISABLED;
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly alias: string,
    public readonly type: EntryPointType
  ) {}
}
